import type { IconProps } from './icons.types';

export function SearchSmallIcon({ size = 14 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      aria-hidden="true"
    >
      <path d="M16.2586 16.2055L19.2049 19.1518" strokeLinecap="square" />
      <path d="M10.6291 17.5219C14.2904 17.5219 17.2584 14.7188 17.2584 11.2609C17.2584 7.80305 14.2904 4.99989 10.6291 4.99989C6.96782 4.99989 3.99977 7.80305 3.99977 11.2609C3.99977 14.7188 6.96782 17.5219 10.6291 17.5219Z" />
    </svg>
  );
}
